import { isPlatformBrowser, NgClass } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  ChangeDetectorRef,
  AfterViewInit,
  InjectionToken,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { AbstractControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormField } from '@teamfoster/dynamic-forms';
import { IconComponent } from '../../../core/components/icon/icon.component';

@Component({
  selector: 'app-form-radio-list',
  templateUrl: './form-radio-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    ngSkipHydration: 'true',
  },
  imports: [FormsModule, ReactiveFormsModule, NgClass, IconComponent],
})
export class FormRadioListComponent implements OnInit, AfterViewInit {
  private cd = inject(ChangeDetectorRef);
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);

  @ViewChild('collapsable') collapsable?: ElementRef;
  config!: DynamicFormField;
  group!: UntypedFormGroup;

  collapsed = true;
  collapsableHeight?: string;

  ngOnInit(): void {
    if (this.config?.value) {
      this.group.get(this.config.name)?.patchValue(this.config.value);
    }
    if (this.config?.['groupOpen']) {
      this.collapsed = false;
    }
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.collapsableHeight = `${this.collapsable?.nativeElement.clientHeight}px`;
    this.cd.detectChanges();
  }

  showError(field: AbstractControl) {
    return field.invalid && (field.touched || field.dirty);
  }

  isRequired(field: AbstractControl) {
    if (!field.validator) {
      return false;
    }
    const validator = field?.validator({} as AbstractControl);
    return validator && validator['required'];
  }

  error(ctrl: AbstractControl) {
    if (ctrl.hasError('required')) {
      return 'Dit veld is verplicht.';
    }
    return '';
  }

  toggleOption(id: number | string) {
    if (this.group.get(this.config.name)?.value !== id) {
      this.group.get(this.config.name)?.patchValue(id);
    } else {
      this.group.get(this.config.name)?.reset();
    }
  }
}
